import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Scrollbars from "react-custom-scrollbars-2";
import { SidebarData } from "./sidebarData";
import ImageWithBasePath from "./imageWithBasePath";
import "./style.css"
// import { useDispatch, useSelector } from "react-redux";
// import { setExpandMenu } from "../../data/redux/commonSlice";
import { all_routes } from "./all_routes";

const Sidebar = () => {
  const Location = useLocation();

  const [headerCollapse,setheaderCollapse ]=React.useState(false)
  const [mobileSidebar,setmobileSidebar] = React.useState(false);
  const [miniSidebar] = React.useState(false);
  const [expandMenu,setexpandMenu] = React.useState(false);
  // const expandMenu = useSelector((state: any) => state.expandMenu);
  // const dispatch = useDispatch();

  console.log("Location.pathname", Location.pathname);


  const toggle = () => {
    // dispatch(setExpandMenu(expandMenu ? false : true));
  };
  const toggleExpandMenu = () => {
    // dispatch(setExpandMenu(!expandMenu));
  };
  const toggleMiniSidebar = () => {
    // dispatch(setMiniSidebar(!miniSidebar));
  };
  const toggleMobileSidebar = () => {
    setmobileSidebar((pre)=>!pre)
    setexpandMenu((pre)=>!pre)
    // dispatch(setMobileSidebar(!mobileSidebar));
  };
  const [subOpen, setSubopen] = useState("");
  const [subsidebar, setSubsidebar] = useState("");

  const toggleSidebar = (title) => {
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };
  return (
    <>
        <div>
       <div
        className={`main-wrapper 
        // ${headerCollapse ? "header-collapse" : ""} 
        ${mobileSidebar ? "slide-nav" : ""}
        // ${miniSidebar ? "mini-sidebar" : ""}
        ${expandMenu ? "expanded-menu" : ""}`}
      >
        {/* <ALLRoutes /> */}
        <div className="header" onClick={toggleExpandMenu}>
        {/* Logo */}
        <div className="header-left active">

          <Link to={""} className="logo-small">
            <ImageWithBasePath src="img/alphai-logo.webp" alt="Logo"  />
          </Link>
          <Link id="toggle_btn" to="#" onClick={toggleMiniSidebar}>
          <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-bar-to-left"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 12l10 0" /><path d="M10 12l4 4" /><path d="M10 12l4 -4" /><path d="M4 4l0 16" /></svg>
          </Link>
        </div>
        {/* /Logo */}
        <Link
          id="mobile_btn"
          className="mobile_btn"
          to="#sidebar"
          onClick={toggleMobileSidebar}
        >
          <span className="bar-icon">
            <span />
            <span />
            <span />
          </span>
        </Link>

      
      </div>
      <div
        className={`sidebar ${headerCollapse===false?"m":""} `}
        id="sidebar"
        // style={{marginLeft:headerCollapse===false?"0px":""}}
      // onMouseEnter={toggle}
      // onMouseLeave={toggle}
      >
        {/* <Scrollbars> */}
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                {SidebarData?.map((mainLabel, index) => (
                  <li className="clinicdropdown" key={index}>
                    <h6 className="submenu-hdr">{mainLabel?.label}</h6>

                    <ul>
                      {mainLabel?.submenuItems?.map((title,i) => {
                        let link_array= [];
                        if ("submenuItems" in title) {
                          title.submenuItems?.map((link) => {
                            link_array.push(link?.link);
                            if (link?.submenu && "submenuItems" in link) {
                              link.submenuItems?.map((item) => {
                                link_array.push(item?.link);
                              });
                            }
                          });
                        }
                        title.links = link_array;

                        return (
                          <>
                            <li className="submenu" key={i}>
                              <Link
                                to={title?.link === all_routes.leadsDashboard ? "/" : title?.link}
                                onClick={() => toggleSidebar(title?.label)}
                                className={`${subOpen == title?.label
                                    ? "subdrop active"
                                    : ""
                                  } ${title?.links?.includes(Location.pathname)
                                    ? "active"
                                    : ""
                                  }
                            `}
                              >
                                {/* <Grid /> */}
                                {/* <i className={title.icon}></i> */}

                                <span>{title?.label}</span>
                                <span
                                  className={title?.submenu ? "menu-arrow" : ""}
                                />
                              </Link>
                              <ul
                                className={subOpen === title?.label ? "visible" : "hidden"}
                                
                                // style={{
                                //   display:
                                //     subOpen == title?.label ? "block !important" : "none",
                                // }}
                              >
                                {title?.submenuItems?.map(
                                  (item, titleIndex) => (
                                    <li
                                      className="submenu submenu-two"
                                      key={titleIndex}
                                    >
                                      {item.lebel}
                                      <Link
                                        to={item?.link}
                                        className={
                                          item?.submenuItems
                                            ?.map((link) => link?.link)
                                            .includes(Location.pathname) ||
                                            item?.link == Location.pathname
                                            ? "active"
                                            : ""
                                        }
                                        onClick={() => {
                                          toggleSubsidebar(item?.label);
                                        }}
                                      >
                                        {item?.label}
                                        <span
                                          className={
                                            item?.submenu ? "menu-arrow" : ""
                                          }
                                        />
                                      </Link>
                                      <ul
                                        style={{
                                          display:
                                            subsidebar == item?.label
                                              ? "block"
                                              : "none",
                                        }}
                                      >
                                        {item?.submenuItems?.map(
                                          (items, titleIndex) => (
                                            <li key={titleIndex}>
                                              {/* {item.lebel} */}
                                              <Link
                                                to={items?.link}
                                                className={`${subsidebar == items?.label
                                                    ? "submenu-two subdrop"
                                                    : "submenu-two"
                                                  } ${items?.submenuItems
                                                    ?.map(
                                                      (link) => link.link
                                                    )
                                                    .includes(
                                                      Location.pathname
                                                    ) ||
                                                    items?.link ==
                                                    Location.pathname
                                                    ? "active"
                                                    : ""
                                                  }`}
                                              >
                                                {items?.label}
                                              </Link>
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    </li>
                                  )
                                )}
                              </ul>
                            </li>
                          </>
                        );
                      })}
                    </ul>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        {/* </Scrollbars> */}
      </div>
      </div>
      <div className="sidebar-overlay"></div>
      <div
        className={`sidebar-themeoverlay open`}
     
      ></div>
    </div>
  
    </>
  );
};

export default Sidebar;
